import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import ProductImageMobile from '../ProductImageMobile';
import { formatDateWithoutTime } from '../../../../../../helpers/DateFormatter';
import { priceFormatter } from '../../../../../../helpers/ProductHelper';
import { useDetailInformationStyles } from './styles';

const DetailInformation = ({ ...props }) => {
  const {
    name,
    orderId,
    sku,
    quantity,
    totalPrice,
    purchaseDate,
    isMkp,
    thumbnailImage,
    purchaseState,
  } = props;
  const classes = useDetailInformationStyles();
  return (
    <Box display="flex" className={classes.container}>
      <ProductImageMobile
        isMkp={isMkp}
        src={thumbnailImage}
        purchaseState={purchaseState}
        sku={sku}
      />
      <Box display="flex" flexDirection="column">
        <Typography className={classes.title}> {name} </Typography>
        <Typography className={classes.subtitle}>
          <span className={classes.subtitleWeight}>Nº de compra:</span>{' '}
          {orderId}{' '}
        </Typography>
        <Typography className={classes.subtitle}>
          <span className={classes.subtitleWeight}>SKU:</span> {sku}{' '}
        </Typography>
        <Typography className={classes.subtitle}>
          <span className={classes.subtitleWeight}>Cantidad:</span> {quantity}{' '}
        </Typography>
        <Typography className={classes.subtitle}>
          <span className={classes.subtitleWeight}>Total:</span>{' '}
          {priceFormatter(totalPrice)}
        </Typography>
        <Typography className={classes.subtitle}>
          <span className={classes.subtitleWeight}>Fecha de compra:</span>{' '}
          {formatDateWithoutTime(purchaseDate)}{' '}
        </Typography>
      </Box>
    </Box>
  );
};

DetailInformation.propTypes = {
  name: PropTypes.string,
  orderId: PropTypes.number,
  sku: PropTypes.string,
  quantity: PropTypes.number,
  totalPrice: PropTypes.number,
  purchaseDate: PropTypes.string,
  isMkp: PropTypes.bool,
  thumbnailImage: PropTypes.string,
  purchaseState: PropTypes.string,
};

export default DetailInformation;
